import { useKeycloak } from '@react-keycloak/web';

export const LogoutButton = () => {
  const { keycloak } = useKeycloak();

  const handleLogout = () => {
    keycloak.logout();
  };

  return (
    <span onClick={handleLogout}>Logout</span>
  );
}